<template>
  <page :title="title" :breadcrumb="breadcrumb" :load="doInit">
    <template slot="pageAction">
      <div class="actionBlock">
        <v-menu offset-y :min-width="250">
          <template v-slot:activator="{ on }">
            <v-btn text color="secondary" v-on="on">
              More Links...
              <v-icon right>mdi-link</v-icon>
            </v-btn>
          </template>
          <side-function-menu :items="sideFunction" @doClick="sideMenuClick"></side-function-menu>
        </v-menu>
      </div>
    </template>
    <v-card>
      <v-card-title v-if="newIntermediary">
        <span class="title">New Intermediary</span>
      </v-card-title>
      <v-card-text v-else>
        <v-container fluid grid-list-lg>
          <v-layout row wrap>
            <v-flex xs4>
              <v-checkbox class="queryValue" v-model="intermediary.interNoAe" style="display: inline-block;" disabled>{{ intermediary.interNoAe }}</v-checkbox>
              <v-flex style="display: inline-block; padding-top: 0px;">
                <v-subheader class="queryLabel">{{labels.inter}}</v-subheader>
                <div class="queryValue">{{intermediary.inter}}</div>
              </v-flex>
            </v-flex>
            <v-flex xs4>
              <v-subheader class="queryLabel">{{labels.interGroupName}}</v-subheader>
              <div class="queryValue">{{intermediary.interGroupName}}</div>
            </v-flex>
            <v-flex xs4>
              <v-subheader class="queryLabel">{{labels.intermediaryName}}</v-subheader>
              <div class="queryValue">{{intermediary.intermediaryName}}</div>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card-text>
      <transition name="slide-x-transition" mode="out-in">
        <router-view :routerKey="routerKey"></router-view>
      </transition>
    </v-card>
  </page>
</template>

<script>
import SideFunctionMenu from '@/components/core/claimManagement/sideFunction/SideFunctionMenu'
import { mapGetters, mapActions } from 'vuex'
import routeMixin from '@/mixins/route'

export default {
  data() {
    return {
      labels: {
        inter: 'Intermediary Reference',
        interGroupName: 'Intermediary Group',
        intermediaryName: 'Intermediary Name'
      },
      breadcrumb: [],
      sideMenu: [
        { name: 'reviewProfile', text: 'Profile', icon: 'mdi-account' }
      ],
      sideFunction: [
        { text: 'Profile', icon: 'mdi-account', iconColor: 'primary', params: { key: 'reviewProfile' } }
      ],
      routerKey: undefined,
      newIntermediary: false
    }
  },
  computed: {
    ...mapGetters([
      'derieveBreadcrumbByName',
      'checkAccess'
    ]),
    title() {
      if (this.newIntermediary) {
        return 'New Profile'
      } else {
        return 'Review Profile'
      }
    },
    intermediary() {
      return this.$store.state.adminInter.intermediary
    }
  },
  watch: {
    '$store.state.adminInter.intermediary.intermediaryName': function(value) {
      return this.$store.state.adminInter.intermediary.intermediaryName
    }
  },
  methods: {
    ...mapActions([
      'interMenuInit'
    ]),
    async doInit() {
      if (this.inter === 'new') {
        // do yourself
        this.newIntermediary = true
        this.routerKey = 'reviewProfile'
      } else {
        await this.interMenuInit(this.inter)
        this.routerKey = 'reviewProfile'
        if (this.interGroupCode === '20' || this.interGroupCode === '11') {
          this.sideFunction.push({ text: 'Cedant / Reinsurer', icon: 'mdi-folder-account', iconColor: 'primary', params: { key: 'cedantReinsurerMenu', params: { inter: this.inter, interGroupCode: this.interGroupCode } } })
        }
        this.sideFunction.push({ text: 'Commission Rate', icon: 'mdi-folder-account', iconColor: 'primary', params: { key: 'commissionMenu', params: { inter: this.inter, interGroupCode: this.interGroupCode } } })
        this.sideFunction.push({ text: 'Current Portfolio', icon: 'mdi-folder-account', iconColor: 'primary', params: { key: 'interCurrPortfolioMenu', params: { inter: this.inter, interGroupCode: this.interGroupCode } } })
      }
      this.breadcrumb = this.derieveBreadcrumbByName('intermediaries')
      this.breadcrumb.push({
        name: 'reviewProfile',
        text: this.title
      })
    },
    sideMenuClick(data) {
      this.$router.push({ name: data.key, params: data.params })
    },
    doInterNoAe() {
      if (this.interForm.interNoAe) {
        // this.interForm.inter = null
        this.interForm.interNoAe = true
        this.errors.remove('inter')
      }
    }
  },
  created() {
    this.intermediary.interNoAe = this.interNoAe === 'true'
  },
  props: ['inter', 'interGroupCode', 'interNoAe'],
  components: {
    SideFunctionMenu
  },
  mixins: [
    routeMixin
  ]
}
</script>

<style lang="scss">
@import "../../../assets/scss/accounting.scss";
</style>
